define('views/components/product_category/product_category',['require','backbone','text!templates/components/product_category/product_category.html'],function(require){

    var Backbone = require('backbone');

    var temp = require("text!templates/components/product_category/product_category.html");
    return Backbone.Marionette.ItemView.extend({
        tagName: 'tr',
        template: _.template(temp),
        className: 'product-category-item'
    });
});
